import { useCallback } from 'react';
import { TServerSendRequest } from 'js/hooks/socket/types';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useInboxSubscribe = () => {
    const send = useGenericSend();

    return useCallback(async () => {
        const { data } = await send<TServerSendRequest, Types.IInboxSubscribeResponseData>({
            ID: 70001,
            description: 'Inbox Subscribe',
            responses: [70002]
        });

        return data;
    }, [send]);
};
